import { CognitoUserSession } from 'amazon-cognito-identity-js';
import LoginResponse from "./login-request";

export class SignInSession {
  public id_token: string = '';
  public access_token: string = '';
  public refresh_token: string = '';
  public expires_in: number = 0;
  public token_type: string = '';

  public FromLoginResponse(resp: LoginResponse): SignInSession {
    this.id_token = resp.authenticationResult?.idToken || '';
    this.access_token = resp.authenticationResult?.accessToken || '';
    this.refresh_token = resp.authenticationResult?.refreshToken || '';
    this.expires_in = resp.authenticationResult?.expiresIn || 0;
    this.token_type = resp.authenticationResult?.tokenType || 'Bearer';
    return this;
  }

  public FromCognito(userSession: CognitoUserSession): SignInSession {
    this.id_token = userSession.getIdToken().getJwtToken();
    this.access_token = userSession.getAccessToken().getJwtToken();
    this.refresh_token = userSession.getRefreshToken().getToken();
    this.token_type = 'Bearer';
    return this;
  }
}
